import type { SnapshotId } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useLocale } from 'containers/App/LocaleContext';
import type { Snapshot } from 'pages/SnapshotManagement/snapshotManagementTypes';
import { memo } from 'react';
import type { FC } from 'react';

import Select, { type Options } from 'react-select';
import { SelectSnapshotOption } from './SelectSnapshotOption';
import { SelectSnapshotValue } from './SelectSnapshotValue';
import './SelectSnapshot.css';

interface Props {
  clearable?: boolean;
  disabled?: boolean;
  isOptionDisabled?: (
    option: Snapshot,
    options: Options<Snapshot>,
  ) => boolean | false;
  onChange: (id: SnapshotId | null) => void;
  placeholder?: string;
  snapshots: Snapshot[];
  value: SnapshotId | null;
}

const BareSelectSnapshot: FC<Props> = (props) => {
  const selectSnapshotMsg = useLocale().generic.components.selectSnapshot;

  return (
    <Select
      className='select-snapshot'
      classNamePrefix='react-select'
      components={{
        Option: SelectSnapshotOption,
        SingleValue: SelectSnapshotValue,
      }}
      isClearable={props.clearable}
      isOptionDisabled={props.isOptionDisabled}
      isSearchable={false}
      name='select-snapshot'
      getOptionValue={prop('id')}
      // option should be always non-array value
      onChange={(option) => {
        props.onChange((option as Snapshot)?.id ?? null);
      }}
      options={props.snapshots}
      placeholder={
        props.placeholder ??
        (props.snapshots.length === 0
          ? selectSnapshotMsg.placeholderNoSnapshots
          : selectSnapshotMsg.placeholder)
      }
      value={
        props.snapshots.find((option) => option.id === props.value) ?? null
      }
      isDisabled={props.disabled || props.snapshots.length === 0}
    />
  );
};

export const SelectSnapshot = memo(BareSelectSnapshot);
